import _classCallCheck from "/Users/blainelewis/projects/blainelewis1.github.io/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/blainelewis/projects/blainelewis1.github.io/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/Users/blainelewis/projects/blainelewis1.github.io/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/blainelewis/projects/blainelewis1.github.io/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/blainelewis/projects/blainelewis1.github.io/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _defineProperty from "/Users/blainelewis/projects/blainelewis1.github.io/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _toConsumableArray from "/Users/blainelewis/projects/blainelewis1.github.io/node_modules/@babel/runtime/helpers/esm/toConsumableArray";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { isArgmaxDef, isArgminDef } from '../../aggregate';
import { getPositionChannelFromLatLong, getSecondaryRangeChannel, isGeoPositionChannel, isScaleChannel } from '../../channel';
import { binRequiresRange, hasBandEnd, isTypedFieldDef, vgField } from '../../channeldef';
import * as log from '../../log';
import { duplicate, hash as _hash, keys, replacePathInField, setEqual } from '../../util';
import { isUnitModel } from '../model';
import { DataFlowNode } from './dataflow';

function addDimension(dims, channel, fieldDef, model) {
  var channelDef2 = isUnitModel(model) ? model.encoding[getSecondaryRangeChannel(channel)] : undefined;

  if (isTypedFieldDef(fieldDef) && isUnitModel(model) && hasBandEnd(fieldDef, channelDef2, model.markDef, model.config)) {
    dims.add(vgField(fieldDef, {}));
    dims.add(vgField(fieldDef, {
      suffix: 'end'
    }));

    if (fieldDef.bin && binRequiresRange(fieldDef, channel)) {
      dims.add(vgField(fieldDef, {
        binSuffix: 'range'
      }));
    }
  } else if (isGeoPositionChannel(channel)) {
    var posChannel = getPositionChannelFromLatLong(channel);
    dims.add(model.getName(posChannel));
  } else {
    dims.add(vgField(fieldDef));
  }

  return dims;
}

function mergeMeasures(parentMeasures, childMeasures) {
  var _a;

  var _iterator = _createForOfIteratorHelper(keys(childMeasures)),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var field = _step.value;
      // when we merge a measure, we either have to add an aggregation operator or even a new field
      var ops = childMeasures[field];

      var _iterator2 = _createForOfIteratorHelper(keys(ops)),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var op = _step2.value;

          if (field in parentMeasures) {
            // add operator to existing measure field
            parentMeasures[field][op] = new Set([].concat(_toConsumableArray((_a = parentMeasures[field][op]) !== null && _a !== void 0 ? _a : []), _toConsumableArray(ops[op])));
          } else {
            parentMeasures[field] = _defineProperty({}, op, ops[op]);
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
}

export var AggregateNode = /*#__PURE__*/function (_DataFlowNode) {
  _inherits(AggregateNode, _DataFlowNode);

  var _super = _createSuper(AggregateNode);

  /**
   * @param dimensions string set for dimensions
   * @param measures dictionary mapping field name => dict of aggregation functions and names to use
   */
  function AggregateNode(parent, dimensions, measures) {
    var _this;

    _classCallCheck(this, AggregateNode);

    _this = _super.call(this, parent);
    _this.dimensions = dimensions;
    _this.measures = measures;
    return _this;
  }

  _createClass(AggregateNode, [{
    key: "clone",
    value: function clone() {
      return new AggregateNode(null, new Set(this.dimensions), duplicate(this.measures));
    }
  }, {
    key: "groupBy",
    get: function get() {
      return this.dimensions;
    }
  }, {
    key: "merge",
    value: function merge(other) {
      if (setEqual(this.dimensions, other.dimensions)) {
        mergeMeasures(this.measures, other.measures);
        return true;
      } else {
        log.debug('different dimensions, cannot merge');
        return false;
      }
    }
  }, {
    key: "addDimensions",
    value: function addDimensions(fields) {
      fields.forEach(this.dimensions.add, this.dimensions);
    }
  }, {
    key: "dependentFields",
    value: function dependentFields() {
      return new Set([].concat(_toConsumableArray(this.dimensions), _toConsumableArray(keys(this.measures))));
    }
  }, {
    key: "producedFields",
    value: function producedFields() {
      var out = new Set();

      var _iterator3 = _createForOfIteratorHelper(keys(this.measures)),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var field = _step3.value;

          var _iterator4 = _createForOfIteratorHelper(keys(this.measures[field])),
              _step4;

          try {
            for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
              var op = _step4.value;
              var m = this.measures[field][op];

              if (m.size === 0) {
                out.add("".concat(op, "_").concat(field));
              } else {
                m.forEach(out.add, out);
              }
            }
          } catch (err) {
            _iterator4.e(err);
          } finally {
            _iterator4.f();
          }
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }

      return out;
    }
  }, {
    key: "hash",
    value: function hash() {
      return "Aggregate ".concat(_hash({
        dimensions: this.dimensions,
        measures: this.measures
      }));
    }
  }, {
    key: "assemble",
    value: function assemble() {
      var ops = [];
      var fields = [];
      var as = [];

      var _iterator5 = _createForOfIteratorHelper(keys(this.measures)),
          _step5;

      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var field = _step5.value;

          var _iterator6 = _createForOfIteratorHelper(keys(this.measures[field])),
              _step6;

          try {
            for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
              var op = _step6.value;

              var _iterator7 = _createForOfIteratorHelper(this.measures[field][op]),
                  _step7;

              try {
                for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
                  var alias = _step7.value;
                  as.push(alias);
                  ops.push(op);
                  fields.push(field === '*' ? null : replacePathInField(field));
                }
              } catch (err) {
                _iterator7.e(err);
              } finally {
                _iterator7.f();
              }
            }
          } catch (err) {
            _iterator6.e(err);
          } finally {
            _iterator6.f();
          }
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }

      var result = {
        type: 'aggregate',
        groupby: _toConsumableArray(this.dimensions).map(replacePathInField),
        ops: ops,
        fields: fields,
        as: as
      };
      return result;
    }
  }], [{
    key: "makeFromEncoding",
    value: function makeFromEncoding(parent, model) {
      var isAggregate = false;
      model.forEachFieldDef(function (fd) {
        if (fd.aggregate) {
          isAggregate = true;
        }
      });
      var meas = {};
      var dims = new Set();

      if (!isAggregate) {
        // no need to create this node if the model has no aggregation
        return null;
      }

      model.forEachFieldDef(function (fieldDef, channel) {
        var _a, _b, _c, _d;

        var aggregate = fieldDef.aggregate,
            field = fieldDef.field;

        if (aggregate) {
          if (aggregate === 'count') {
            (_a = meas['*']) !== null && _a !== void 0 ? _a : meas['*'] = {};
            meas['*']['count'] = new Set([vgField(fieldDef, {
              forAs: true
            })]);
          } else {
            if (isArgminDef(aggregate) || isArgmaxDef(aggregate)) {
              var op = isArgminDef(aggregate) ? 'argmin' : 'argmax';
              var argField = aggregate[op];
              (_b = meas[argField]) !== null && _b !== void 0 ? _b : meas[argField] = {};
              meas[argField][op] = new Set([vgField({
                op: op,
                field: argField
              }, {
                forAs: true
              })]);
            } else {
              (_c = meas[field]) !== null && _c !== void 0 ? _c : meas[field] = {};
              meas[field][aggregate] = new Set([vgField(fieldDef, {
                forAs: true
              })]);
            } // For scale channel with domain === 'unaggregated', add min/max so we can use their union as unaggregated domain


            if (isScaleChannel(channel) && model.scaleDomain(channel) === 'unaggregated') {
              (_d = meas[field]) !== null && _d !== void 0 ? _d : meas[field] = {};
              meas[field]['min'] = new Set([vgField({
                field: field,
                aggregate: 'min'
              }, {
                forAs: true
              })]);
              meas[field]['max'] = new Set([vgField({
                field: field,
                aggregate: 'max'
              }, {
                forAs: true
              })]);
            }
          }
        } else {
          addDimension(dims, channel, fieldDef, model);
        }
      });

      if (dims.size + keys(meas).length === 0) {
        return null;
      }

      return new AggregateNode(parent, dims, meas);
    }
  }, {
    key: "makeFromTransform",
    value: function makeFromTransform(parent, t) {
      var _a, _b, _c;

      var dims = new Set();
      var meas = {};

      var _iterator8 = _createForOfIteratorHelper(t.aggregate),
          _step8;

      try {
        for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
          var s = _step8.value;
          var op = s.op,
              field = s.field,
              as = s.as;

          if (op) {
            if (op === 'count') {
              (_a = meas['*']) !== null && _a !== void 0 ? _a : meas['*'] = {};
              meas['*']['count'] = new Set([as ? as : vgField(s, {
                forAs: true
              })]);
            } else {
              (_b = meas[field]) !== null && _b !== void 0 ? _b : meas[field] = {};
              meas[field][op] = new Set([as ? as : vgField(s, {
                forAs: true
              })]);
            }
          }
        }
      } catch (err) {
        _iterator8.e(err);
      } finally {
        _iterator8.f();
      }

      var _iterator9 = _createForOfIteratorHelper((_c = t.groupby) !== null && _c !== void 0 ? _c : []),
          _step9;

      try {
        for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
          var _s = _step9.value;
          dims.add(_s);
        }
      } catch (err) {
        _iterator9.e(err);
      } finally {
        _iterator9.f();
      }

      if (dims.size + keys(meas).length === 0) {
        return null;
      }

      return new AggregateNode(parent, dims, meas);
    }
  }]);

  return AggregateNode;
}(DataFlowNode);